import ProfilePicture from "src/components/ProfilePicture";
import { CommentBubbleMarginSize } from "../constants";
import { CommentAttachmentType, CommentBubbleProps } from "../types";

const ProfilePicturePadding = 8;

const CommentAttachmentProfilePicture = ({
	attachment,
	sender,
	bottom = 0,
}: {
	attachment: CommentAttachmentType.ProfilePicture;
	sender: NonNullable<CommentBubbleProps["sender"]>;
	bottom?: number;
}) => {
	return (
		<ProfilePicture
			userId={attachment.userId}
			size={CommentBubbleMarginSize - 2 * ProfilePicturePadding}
			style={[
				{
					position: "absolute",
					bottom,
				},
				sender === "Other" && {
					left: ProfilePicturePadding,
				},
				sender === "Self" && {
					right: ProfilePicturePadding,
				},
			]}
		/>
	);
};
export default CommentAttachmentProfilePicture;
